const addAdminEmailReducer = (state = {}, action) => {
    switch (action.type) {
      case "ADD_ADMIN_EMAIL": {
        return{
          ...state,
          addAdminEmailSuccess: action.success
        }
      }
      case "ADD_ADMIN_EMAIL_ERR": {
        return{
          ...state,
          addAdminEmailError: action.err
        }
      }
      default:
        return state;
    }
  };
  
  export default addAdminEmailReducer;